import React from 'react';
import { FacebookIcon, InstagramIcon, LinkedinIcon, YoutubeIcon } from 'lucide-react';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/oaQANTmLmdH94jWkAeshbq/LetLois_Logo_Wide_Lapels_Blue_Transparent_(1).png';
interface FooterColumn {
  title: string;
  links: string[];
}
const COLUMNS: FooterColumn[] = [{
  title: 'Services',
  links: ['Consulting', 'Google Ads', 'Meta Ads', 'Websites', 'GHL Setup']
}, {
  title: 'Pages',
  links: ['Home', 'About', 'Pricing', 'Contact']
}, {
  title: 'Legal',
  links: ['Privacy Policy', 'Cookie Policy', 'Terms of Use']
}, {
  title: 'Contact',
  links: ['Gilbert, AZ', 'Book a call', 'GoHighLevel partner']
}];
const SOCIAL_LINKS = [{
  label: 'Instagram',
  icon: InstagramIcon
}, {
  label: 'Facebook',
  icon: FacebookIcon
}, {
  label: 'YouTube',
  icon: YoutubeIcon
}, {
  label: 'LinkedIn',
  icon: LinkedinIcon
}];
export function Footer() {
  return <footer className="w-full bg-black text-white" data-id="element-73" data-mp="2eyt9iquuu9rc">
      <div className="mx-auto max-w-7xl px-6 py-16 lg:px-10 lg:py-20" data-id="element-74" data-mp="2ew6yuico3e4w">
        <div className="grid gap-14 lg:grid-cols-[1.35fr_3fr] lg:gap-20" data-id="element-75" data-mp="3labqfslx60os">
          <div data-id="element-76" data-mp="3gb8wb37h9evl">
            <a href="#" className="flex items-center" aria-label="LetLois home" data-id="element-77" data-mp="3gbr0qn4amzel">
              <img src={LOGO_URL} alt="LetLois" className="h-10 w-auto max-w-[170px] object-contain object-left" data-id="element-78" data-mp="3v7zx9gwsuynb" />
            </a>
            <p className="mt-4 max-w-xs font-mono-eyebrow text-[10px] font-semibold uppercase leading-relaxed tracking-[0.16em] text-brand-blue" data-id="element-79" data-mp="3q7264ettau9o">
              // Websites, ads & consulting for med spas and home services.
            </p>
            <div className="mt-7 flex gap-3" aria-label="Social media" data-id="element-80" data-mp="hsttwhblkg3o">
              {SOCIAL_LINKS.map(({
              label,
              icon: Icon
            }) => <a key={label} href="#" aria-label={label} className="flex h-10 w-10 items-center justify-center border border-brand-blue/70 text-white transition-colors hover:bg-brand-blue hover:text-black focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-blue" data-id="element-81" data-mp="cus0b2gjoydy">
                  <Icon className="h-4 w-4" aria-hidden="true" data-id="element-82" data-mp="yty0xuoj2v56" />
                </a>)}
            </div>
          </div>

          <div className="grid grid-cols-2 gap-x-8 gap-y-12 sm:grid-cols-4" data-id="element-83" data-mp="13s9980z6cxla">
            {COLUMNS.map(column => <div key={column.title} data-id="element-84" data-mp="18lk6pbi3k20j">
                <h3 className="font-mono-eyebrow text-[10px] font-semibold uppercase tracking-[0.18em] text-brand-blue" data-id="element-85" data-mp="1clmaprbb17iz">
                  {column.title}
                </h3>
                <ul className="mt-6 space-y-3" data-id="element-86" data-mp="1hms5rvsft6vo">
                  {column.links.map(link => <li key={link} data-id="element-87" data-mp="1mhpcux65p65x">
                      <a href="#" className="text-sm text-white/55 transition-colors hover:text-white focus:outline-none focus-visible:text-brand-blue" data-id="element-88" data-mp="1rilipga2j2dz">
                        {link}
                      </a>
                    </li>)}
                </ul>
              </div>)}
          </div>
        </div>

        <div className="mt-16 flex flex-col items-start justify-between gap-4 border-t border-white/10 pt-7 sm:flex-row sm:items-center" data-id="element-89" data-mp="2afx1gwpjm34e">
          <p className="font-mono-eyebrow text-[10px] uppercase tracking-[0.1em] text-white/30" data-id="element-90" data-mp="25mkdmosou0cp">© {new Date().getFullYear()} LetLois LLC. All rights reserved.</p>
          <div className="flex flex-wrap gap-x-5 gap-y-2" data-id="element-91" data-mp="1wp0ebledye4q">
            {['Privacy Policy', 'Cookie Policy', 'Terms of Use'].map(link => <a key={link} href="#" className="font-mono-eyebrow text-[10px] uppercase tracking-[0.1em] text-white/30 transition-colors hover:text-white" data-id="element-92" data-mp="2pcecfmttlfqf">
                {link}
              </a>)}
          </div>
        </div>
      </div>
    </footer>;
}